import React from "react";

export const SmallLogoSvg: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="none">
      <path
        fill-rule="evenodd"
        d="M12.218 24.436A12.22 12.22 0 0 1 0 12.218 12.22 12.22 0 0 1 12.218 0a12.22 12.22 0 0 1 12.218 12.218 12.22 12.22 0 0 1-12.218 12.218z"
        fill="#fe7a20"
      ></path>
      <g fill="#fff">
        <path d="M16.364 4.8a1.53 1.53 0 0 0-1.527 1.527v10.909a1.53 1.53 0 0 0 1.527 1.527 1.53 1.53 0 0 0 1.527-1.527V6.327A1.53 1.53 0 0 0 16.364 4.8zm-4.8 2.618a1.53 1.53 0 0 0-1.527 1.527v8.291a1.53 1.53 0 0 0 1.527 1.527 1.53 1.53 0 0 0 1.527-1.527V8.945a1.53 1.53 0 0 0-1.527-1.527zm-4.8 2.618a1.53 1.53 0 0 0-1.527 1.527v5.673a1.53 1.53 0 0 0 1.527 1.527 1.53 1.53 0 0 0 1.527-1.527v-5.673a1.53 1.53 0 0 0-1.527-1.527z"></path>
      </g>
    </svg>
  );
};
